export default Object.freeze({
  EMAIL: 'contactEmail',
})
